module.exports = __webpack_public_path__ + "static/features-slide1@2x-f43b8d2d4ac79d2a241d19df6f7dd141.png";